import styled from 'styled-components';

const CenterForm = styled.form`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 400px;
  display: grid;
  gap: .5rem;
`;

export default CenterForm;